import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

import { getDefaultBaseVerificationIntakeStatus } from './getDefaultBaseVerificationIntakeStatus.ts';

type MergePatientDataWithIntakeStatusParams = {
  patientData: Record<string, unknown> | null;
  baseSteps: IntakeStatusBaseSteps | null;
};

export const mergePatientDataWithIntakeStatus = ({
  patientData,
  baseSteps,
}: MergePatientDataWithIntakeStatusParams) => {
  if (!patientData) {
    return baseSteps;
  }

  const defaultBaseVerification = getDefaultBaseVerificationIntakeStatus(patientData);

  return {
    ...defaultBaseVerification,
    ...baseSteps,
  };
};
